
import { GET_CLIENT_ORDERS, GET_ORDERS } from './actionTypes'
import jsPDF from 'jspdf';
import "jspdf-autotable"
import dayjs from "dayjs";
import "dayjs/locale/nl";
import { firebaseAuth, firestoreDB } from '../../utils/firebase'
import { CLIENT_ID } from '../../utils/config'
import { showMessageModal } from './miscActions'

dayjs.locale("nl");

export const getAllOrders = () => dispatch => {
  firestoreDB.collection('orders').where('store', '==', CLIENT_ID).where('isArchived', '==', false).onSnapshot(function(querySnapshot){
    let orders = []
    querySnapshot.forEach(function(doc){
      const order = doc.data();
      order.id = doc.id;
      order.key = doc.id;
      orders.push(order)
    })
    dispatch({
      type: GET_ORDERS,
      payload: orders
    })
  })
}

export const getUserOrders = () => dispatch => {
  const user = firebaseAuth.currentUser;
  if(user){
    firestoreDB.collection('orders').where('store', '==', CLIENT_ID).where('isArchived', '==', false).where('user','==', user.uid).onSnapshot(function(querySnapshot){
      let custOrders = []
      querySnapshot.forEach(function(doc){
        let custOrder = {};
        custOrder.id = doc.id;
        custOrder.cart = doc.data().cart;
        custOrder.date = doc.data().date;
        custOrder.orderCost = doc.data().orderCost;
        custOrder.orderNumber = doc.data().orderNumber;
        custOrder.status = doc.data().status;
        custOrder.updatedStatus = doc.data().updatedStatus;
        custOrder.key = doc.id;

        custOrders.push(custOrder)
      })
      dispatch({
        type: GET_CLIENT_ORDERS,
        payload: custOrders
      })
    })
  }
}

export const cancelOrder = (id, status, updatedStatus)=> dispatch => {
  const feedback = {
    type: 'loading',
    txt: 'Aan het opslaan'
  }
  dispatch(showMessageModal(feedback))

  if(status === 'pending'){
    firestoreDB.collection('orders').doc(id).update({
      status: 'cancelled',
      updatedStatus: 'klant'
    }).then(function(){
      const feedback = {
        type: 'success',
        txt: 'Het bijwerken is gelukt'
      }
      dispatch(
        showMessageModal(feedback)
        )
      }).catch((error)=>{
        const feedback = {
          type: 'warning',
          txt: 'Opslaan mislukt. Probeer het later weer.'
        }
        dispatch(
          showMessageModal(feedback)
          )
        })
  } else if(status === 'cancelled') {
    const feedback = {
      type: 'warning',
      txt: `Deze bestelling is al reeds door de ${updatedStatus === 'admin' ? 'vendor' : 'klant'} geanulleerd.`
    }
    dispatch(
      showMessageModal(feedback)
      )
  } else {
    const feedback = {
      type: 'warning',
      txt: `Het is niet mogelijk om een bestelling die ${status === 'processing' ? 'in behandeling is' : status === 'done' ? 'reeds is afgewerkt' : ''} te annuleren. Voor meer informatie kunt u contact met ons opnemen op het nummer 439 244`
    }
    dispatch(
      showMessageModal(feedback)
      )
  }

}

export const updateOrderStatus =(id, status, updatedStatus)=> dispatch =>{
  const feedback = {
    type: 'loading',
    txt: 'Aan het opslaan'
  }
  dispatch(showMessageModal(feedback))

  if(updatedStatus === 'klant'){
    const feedback = {
      type: 'warning',
      txt: 'Kan de status niet bijwerken'
    }
    dispatch(showMessageModal(feedback))
  } else {
    firestoreDB.collection('orders').doc(id).update({
      status,
      updatedStatus: 'admin'
    }).then(function(){
      const feedback = {
        type: 'success',
        txt: 'Het bijwerken is gelukt'
      }
      dispatch(
        showMessageModal(feedback)
        )
      }).catch((error)=>{
        const feedback = {
          type: 'warning',
          txt: 'Opslaan mislukt. Probeer het later weer.'
        }
        dispatch(
          showMessageModal(feedback)
          )
        })
      }
}

export const archiveOrder = (id) => dispatch => {
  firestoreDB.collection('orders').doc(id).update({
    isArchived: true
  }).then(function(){
    const feedback = {
      type: 'success',
      txt: 'Order gearchiveerd'
    }
    dispatch(
      showMessageModal(feedback)
    )
  }).catch((error)=>{
    const feedback = {
      type: 'warning',
      txt: 'Opslaan mislukt. Probeer het later weer.'
    }
    dispatch(
      showMessageModal(feedback)
    )
  })
}

export const downloadPdf = (data) => dispatch => {

  const {
    date,
    orderNumber,
    orderCost,
    cust,
    cart,
  } = data;
  const cats = ["groenten", "fruit", "sap", "aardvrucht", "specerijen"];
  const adress = `${cust.adress} #${cust.houseNum}`
  var doc = new jsPDF(
    'a4'
  ) 

    let rows = []
    cart.forEach((x) => {
      rows.push([
        x.productId.length > 0 ? x.productId : "-",
        x.productCategorie === "pakket" ? x.pakketNaam : x.productNaam,
        x.productCategorie === "pakket"
          ? "pakket"
          : x.productAttributen.toString().split(",").join(" - "),
          x.productCategorie === "pakket" ? x.quantity + " x" : x.quantity + " x " + x.productEenheid,
        cats.includes(x.productCategorie.toString()) && x.productOnSale
          ? new Intl.NumberFormat("IN", {
              style: "currency",
              currency: "SRD",
            }).format(`${x.itemSalesPrice}`)
          : new Intl.NumberFormat("IN", {
              style: "currency",
              currency: "SRD",
            }).format(`${x.itemPrice}`),
      ]);
    });

    var logo = document.createElement('img');

  logo.src = require(('./bonanza-logo.png'));
  doc.addImage(logo, 'PNG', 13, 5, 40, 28)

  doc.setFontStyle("bold");
  doc.setFontSize(14);
  doc.text(55, 25, 'Order#');   
  
  doc.setFontStyle("normal");
  doc.setFontSize(12);
  doc.text(72, 25, orderNumber);

  doc.setFontStyle("bold");
  doc.setFontSize(14);
  doc.text(13, 40, 'Klant informatie'); 
  
  doc.setFontStyle("normal");
  doc.setFontSize(12);
  doc.text(13, 45, cust.name);
  doc.text(13, 50, adress);
  doc.text(13, 55, cust.email);
  doc.text(13, 60, cust.phone);
  doc.text(13, 65, cust.message);

  doc.setFontStyle("bold");
  doc.setFontSize(14);
  doc.text(110, 40, 'Bestel informatie'); 
  
  doc.setFontStyle("normal");
  doc.setFontSize(12);
  doc.text(110, 45, 'Totaal bedrag:'); 
  
  doc.setFontStyle("normal");
  doc.setFontSize(12);
  doc.text(140, 45,  new Intl.NumberFormat("IN", {
    style: "currency",
    currency: "SRD",
  }).format(`${orderCost}`)); 

    doc.setFontStyle("normal");
  doc.setFontSize(12);
  doc.text(110, 50, 'Datum:'); 

  doc.setFontStyle("normal");
  doc.setFontSize(12);
  doc.text(125, 50,  dayjs(date.toDate()).format("DD MMMM YYYY")); 

  doc.autoTable({
    head:[['ID', 'Naam', 'Attributen', 'Aantal', 'Prijs']],
    body: rows,
    margin: { top: 65}
  })

  doc.setFontStyle("bold");
  doc.setFontSize(12);
  doc.text("Contact ons:", 13, doc.autoTable.previous.finalY+10)

  doc.setFontStyle("normal");
  doc.setFontSize(10);
  doc.text("Bonanza Agro Industries", 13, doc.autoTable.previous.finalY+15)
  doc.text("T: +597 439244", 13, doc.autoTable.previous.finalY+20)
  doc.text("A: Muscastraat 16a", 13, doc.autoTable.previous.finalY+25)
  doc.text("E: info@bonanzaagro.sr", 13, doc.autoTable.previous.finalY+30)
  doc.text("W: www.bonanzaagro.sr", 13, doc.autoTable.previous.finalY+35)

  doc.setFontStyle("normal");
  doc.setFontSize(12);
  doc.text("Sub-totaal:", 140, doc.autoTable.previous.finalY+10)
  
  doc.setFontStyle("normal");
  doc.setFontSize(10);
doc.text( new Intl.NumberFormat('IN', { style: 'currency', currency: 'SRD' }).format(orderCost), 170, doc.autoTable.previous.finalY+10)


doc.setFontStyle("normal");
doc.setFontSize(12);
doc.text("Leverkosten:", 140, doc.autoTable.previous.finalY+20)


doc.setFontStyle("normal");
doc.setFontSize(12);
doc.text("Totaal:", 140, doc.autoTable.previous.finalY+30)



  doc.save(orderNumber+'.pdf')
}